import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWidgets from "./FloatingWidgets";
import ExitIntent from "./ExitIntent";
import { Toaster } from "sonner";

export default function Layout() {
  const [theme, setTheme] = useState(() => localStorage.getItem("mfc-theme") || "dark");
  const loc = useLocation();

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    localStorage.setItem("mfc-theme", theme);
  }, [theme]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  return (
    <div className="min-h-screen noise-bg relative">
      <Navbar theme={theme} toggleTheme={() => setTheme((t) => (t === "dark" ? "light" : "dark"))} />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
      <FloatingWidgets />
      <ExitIntent />
      <Toaster position="top-center" theme={theme} richColors />
    </div>
  );
}
